import React from "react";
import { Box, Card, Divider, Text, TextLink } from "@origin-digital/ods-core";
import { IconSearch } from "@origin-digital/ods-icons";
import type { ILabelQueryDto } from "../../contract/generated/bff/src/models";

interface CantFindProps {
  relatedSearches: ILabelQueryDto[];
}

export const CantFind: React.FC<CantFindProps> = ({ relatedSearches }) => {
  if (!relatedSearches.length) return null;

  return (
    <Box
      outline
      data-id="cant-find"
      padding="large"
      borderRadius="medium"
      marginTop="medium"
    >
      <Box marginBottom="small">
        <Text weight="medium" variant="subtitle-small" tone="neutralDark">
          Still can't find what you're looking for?
        </Text>
      </Box>
      {relatedSearches.map((item, index) => (
        <React.Fragment key={item.query}>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="small"
            paddingY="small"
            data-id={`cant-find-row-${index}`}
          >
            <IconSearch color="secondaryB" size="xxsmall" />
            <Text variant="body" weight="regular" tone="neutral">
              <TextLink
                href={`?term=${encodeURIComponent(item.query)}`}
                domProps={{ style: { textDecoration: "none" } }}
              >
                {item.query}
              </TextLink>
            </Text>
          </Box>
          <Divider />
        </React.Fragment>
      ))}
    </Box>
  );
};
